(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/playmaker-widget/assets/javascripts/playmaker-widget.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/playmaker-widget/assets/javascripts/playmaker-widget.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  getBetradarId
} = svs.components.oddset.kambiOffering;
const pmWidgetStyles = svs.components.lbLibs.playmaker.pmWidgetStyles;
const setupSockets = svs.components.oddset.kambiOffering.setupSockets;
const kambiOffering = svs.components.oddset.kambiOffering;
const SocketMessageType = svs.components.oddset.kambiOffering.common.constants.SocketMessageType;
const logger = svs.core.log.getLogger('oddset-kambi:components:playmaker-widget');
class PlaymakerWidget extends HTMLElement {
  constructor() {
    var _this;
    super();
    _this = this;
    _defineProperty(this, "onSocketUpdate", messages => {
      messages.forEach(message => {
        const {
          type,
          payload
        } = message;
        if (type === SocketMessageType.MatchClockUpdated && this.eventId === payload.eventId) {
          var _payload$matchClock;
          if (this.lastUpdateVersion > payload.version) {
            return;
          }
          this.lastUpdateVersion = payload.version;
          this.updateTime((_payload$matchClock = payload.matchClock) === null || _payload$matchClock === void 0 ? void 0 : _payload$matchClock.minute);
        }
      });
    });
    _defineProperty(this, "onSocketError", error => {
      logger.error('Socket error', error);
    });
    _defineProperty(this, "slowPoll", function (fn) {
      let interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
      let timeout = null;
      const poll = () => {
        fn();
        _this.pollingTimeout = setTimeout(poll, interval);
      };
      timeout = setTimeout(poll, interval);
      return () => clearTimeout(timeout);
    });
    _defineProperty(this, "updateTime", matchMinute => {
      var _this$spiderWidget, _this$xgLiveWidget, _this$liveWidget;
      this.currentMatchMinute = matchMinute;
      (_this$spiderWidget = this.spiderWidget) === null || _this$spiderWidget === void 0 || _this$spiderWidget.updateTime(matchMinute);
      (_this$xgLiveWidget = this.xgLiveWidget) === null || _this$xgLiveWidget === void 0 || _this$xgLiveWidget.updateTime(matchMinute);
      (_this$liveWidget = this.liveWidget) === null || _this$liveWidget === void 0 || _this$liveWidget.updateTime(matchMinute);
    });
    _defineProperty(this, "fetchLiveData", async () => {
      try {
        var _liveData$matchClock, _liveData$matchClock2;
        const {
          liveData
        } = await kambiOffering.getLiveData(Number(this.eventId));
        if (!liveData || !liveData.matchClock) {
          return;
        }
        if (this.lastUpdateVersion > liveData.matchClock.version) {
          return;
        }
        if (liveData !== null && liveData !== void 0 && (_liveData$matchClock = liveData.matchClock) !== null && _liveData$matchClock !== void 0 && _liveData$matchClock.running || (liveData === null || liveData === void 0 || (_liveData$matchClock2 = liveData.matchClock) === null || _liveData$matchClock2 === void 0 ? void 0 : _liveData$matchClock2.minute) > 0) {
          clearTimeout(this.pollingTimeout);
          this.subscribe();
          this.updateTime(liveData.matchClock.minute);
        }
      } catch (error) {
        logger.error('Error while fetching kambi livedata', error.message, error.type, error);
      }
    });
    this.spiderWidget = null;
    this.xgLiveWidget = null;
    this.liveWidget = null;
    this.currentMatchMinute = 0;
    this.lastUpdateVersion = 0;
    this.pollingTimeout = null;
    this.subscribe = null;
    this.unsubscribe = null;
  }
  static get observedAttributes() {
    return ['eventid', 'islive'];
  }
  get eventId() {
    return this.getAttribute('eventid');
  }
  get isEventLive() {
    return this.getAttribute('islive') === 'true';
  }
  async connectedCallback() {
    const shadowRoot = this.attachShadow({
      mode: 'open'
    });
    const betradarId = await getBetradarId(this.eventId);
    if (!betradarId) {
      return;
    }

    if (this.eventId) {
      const {
        subscribe,
        unsubscribe
      } = setupSockets(this.eventId, this.onSocketUpdate, this.onSocketError);
      this.subscribe = subscribe;
      this.unsubscribe = unsubscribe;
      if (this.isEventLive) {
        this.subscribe();
      } else {
        this.slowPoll(() => this.fetchLiveData());
      }
    }
    shadowRoot.innerHTML = "\n    <div class=\"pm-widget-container\">\n      <div class=\"pm-spider-container live\">\n        <div id=\"pm-live-widget-summary-".concat(betradarId, "\"></div>\n        <div id=\"pm-xg-live-widget-").concat(betradarId, "\"></div>\n        <div id=\"pm-live-widget-spider-").concat(betradarId, "\"></div>\n      </div>\n    </div>\n    ");
    const style = document.createElement('style');
    style.textContent = "\n      ".concat(pmWidgetStyles, "\n      .pm-widget-container .pm-spider-container {\n        margin-bottom: 30px;\n        background: #3b3737;\n      }");
    shadowRoot.appendChild(style);
    const liveContainer = shadowRoot.querySelector("#pm-live-widget-summary-".concat(betradarId));
    const xgContainer = shadowRoot.querySelector("#pm-xg-live-widget-".concat(betradarId));
    const spiderContainer = shadowRoot.querySelector("#pm-live-widget-spider-".concat(betradarId));
    const pm = window.PM;
    this.spiderWidget = pm('addLiveWidget', _objectSpread(_objectSpread({
      matchId: betradarId
    }, this.isEventLive && {
      gameTime: this.currentMatchMinute
    }), {}, {
      containerElement: spiderContainer,
      settings: {
        kpis: [],
        theme: 'dark',
        renderRadar: true
      }
    }));
    this.xgLiveWidget = pm('addXgLiveWidget', _objectSpread(_objectSpread({
      matchId: betradarId
    }, this.isEventLive && {
      gameTime: this.currentMatchMinute
    }), {}, {
      containerElement: xgContainer,
      settings: {
        theme: 'dark',
        renderLegend: false
      }
    }));
    this.liveWidget = pm('addLiveWidget', _objectSpread(_objectSpread({
      matchId: betradarId
    }, this.isEventLive && {
      gameTime: this.currentMatchMinute
    }), {}, {
      containerElement: liveContainer,
      settings: {
        theme: 'dark',
        renderSummary: true
      }
    }));
  }
  disconnectedCallback() {
    var _this$unsubscribe;
    (_this$unsubscribe = this.unsubscribe) === null || _this$unsubscribe === void 0 || _this$unsubscribe.call(this);
    clearTimeout(this.pollingTimeout);
  }
}
customElements.define('playmaker-widget', PlaymakerWidget);

 })(window);